import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["screen", "children"];
import React, { useEffect } from 'react';
import { AnalyticsContext, useAnalyticsEvents } from '@atlaskit/analytics-next';
import ModalDialog from '@atlaskit/modal-dialog';
import { ANALYTICS_CHANNEL } from '../../constants';
import createEventPayload from '../../utils/analytics/analytics.codegen';
import { ScreenViewedEvent } from '../../utils/analytics/components';
var ModalOpenCloseEvents = function ModalOpenCloseEvents() {
  var _useAnalyticsEvents = useAnalyticsEvents(),
    createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
  useEffect(function () {
    //will fire when modal is mounted
    createAnalyticsEvent(createEventPayload("ui.modalDialog.opened.linkCreate", {})).fire(ANALYTICS_CHANNEL);

    //will fire when modal is unmounted
    return function () {
      createAnalyticsEvent(createEventPayload("ui.modalDialog.closed.linkCreate", {})).fire(ANALYTICS_CHANNEL);
    };
  }, [createAnalyticsEvent]);
  return null;
};

/**
 * AkModal component with built-in analytics for screen event + open + close events + source context
 */
export var Modal = function Modal(_ref) {
  var screen = _ref.screen,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(ModalDialog, props, /*#__PURE__*/React.createElement(AnalyticsContext, {
    data: {
      source: screen,
      component: 'modal'
    }
  }, /*#__PURE__*/React.createElement(ScreenViewedEvent, {
    screen: screen
  }), /*#__PURE__*/React.createElement(ModalOpenCloseEvents, null), children));
};